var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center pa-6"},[_c('v-progress-circular',{attrs:{"size":100,"width":5,"indeterminate":"","color":"teal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }